import { ICard } from '../../../../../../../../../store/model/card/types';

export const getCardTimeSinceLastActivity = (
    card: ICard
): number => {
    const { lastActivityDateStamp } = card;
    return lastActivityDateStamp;
}
